import React, { useCallback, useRef, useState } from "react";
import cx from "classnames";
import { Icon, CountryFlag, useOnClickOutside } from "@wf/components";
import LanguageItem from "./LanguageItem/LanguageItem";
import styles from "./LanguageBar.module.scss";
import { convertCountryCode } from "../../../../helpers";

interface Language {
  name: string;
  displayName: string;
}

interface LanguageBarProps {
  languages: Language[];
  selected: string;
  onChange: (selectedLanguage: string) => void;
  showFlag?: boolean;
  className?: string;
}

const LanguageBar: React.FC<LanguageBarProps> = ({
 languages,
 selected,
 onChange,
 showFlag = true, // Default value for showFlag
 className = "", // Default value for className
}) => {
  const refContainer = useRef(null);
  const current = languages.find(l => l.name === selected);
  const [isDropDownOpened, setIsDropDownOpened] = useState(false);

  const toggleLanguageSelect = useCallback(() => {
    if (languages.length > 1) {
      setIsDropDownOpened(state => !state);
    }
  }, [languages]);

  useOnClickOutside(
    { current: refContainer.current },
    () => {
      setIsDropDownOpened(false);
    },
    { ignoreClassNames: [styles.list] }
  );


  return (
    <div className={cx(styles.languageBar, className)} ref={refContainer}>
      <div onClick={toggleLanguageSelect} className={styles.currentLng}>
        {showFlag && <CountryFlag className={styles.country} code={convertCountryCode(current?.name ?? "")} />}
        <span className={styles.name}>{current?.name ?? ""}</span>
        {/*@ts-ignore*/}
        <Icon className={styles.arrow} name={isDropDownOpened ? "ic_arrow_up" : "ic_arrow_down"} size={10} />
      </div>
      {isDropDownOpened && (
        <ul className={styles.list}>
          {languages
            .filter(item => item.name !== current?.name)
            .map(l => (
              <LanguageItem key={l.name} language={l} onClick={onChange} />
            ))}
        </ul>
      )}
    </div>
  );
};

export default LanguageBar;
